module.exports = __webpack_public_path__ + "static/media/calendar-icon.9e8da0ab.svg";